import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { EnableFor } from '../../../../../../../containers/EnableForRole';
import { useProjectDetailsPermissions } from '../../../../../projectDetails.permissions';
import { FilterTabType } from '../../../imageFilters.model';
import { FilterHeader } from '../FilterHeader';
import { ImageFiltersFormProps } from '../ImageFiltersForm';

export const AnnotatedByHeader = observer((props: ImageFiltersFormProps): ReactElement => {
  const permissions = useProjectDetailsPermissions();
  const canSeeUsers = permissions.canSeeAnnotationAuthors();

  const handleClear = (): void => {
    props.onSetAnnotatedBy([]);
  };

  const isSelected = props.activeFilterType === FilterTabType.AnnotatedBy;
  const count = props.imageFilters.annotatedBy.length;

  return (
    <EnableFor hasPermission={canSeeUsers}>
      <FilterHeader
        filterType={FilterTabType.AnnotatedBy}
        isSelected={isSelected}
        labelKey='annotated_by'
        count={count}
        showClear={count > 0}
        onClear={handleClear}
        onSelect={props.onFilterTabSelect}
      />
    </EnableFor>
  );
});
